// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { gameController, profileManager, inventoryController, inviteFriendManager, customMessagecontroller, flowController } from "../../../game_theme/flow_fb/flowController";
import { tbVectorFont } from "../../engine/tbVectorFont";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { ComponentScrollBox } from "../../framework/components/ComponentScrollbox";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { ComponentLobbyList } from "../../framework/components/componentLobbyList";
import { tgfComponents } from "../../framework/components/tgfComponents";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { DialogLobby } from "../../framework/dialogs/DialogLobby";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfHooks } from "../../framework/hooks/hooks";
import { tgfAudio } from "../../framework/tgfAudio";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfEffects } from "../../framework/tgfEffects";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, CardSettings, CustomUpdateSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { AngryOptionScreenDialog } from "../AngryOptionScreenDialog";
import { angrybirds_regular, angrybirds_regular_text } from "../AssetDefinitions/FontDefinitions";
import { s_button_rectangle2_white, s_bg_placeholder, s_portrait_empty, s_expbar_empty, s_progressbar_bg, s_progressbar_fill_green, s_gemcontainer, s_badgebg, s_icon_gem, s_btn_round_blue, s_icon_settings, s_btn_round_orange_big, s_btn_round_grey_big, s_icon_powerup, s_powerupcount, s_startFriend, transparent_4x4, s_startRandom, s_friend_invite_matilda, s_btn_round_green_small, s_icon_plus, s_terence_timer_lobby, s_progress_bar_fill, s_profile_placeholder } from "../AssetDefinitions/ImageDefinitions";
import { s_notification, s_smokePuff } from "../AssetDefinitions/SpineDefinitions";
import { DailyRewardManager } from "../DailyRewardManager";
import { ExpManager } from "../ExpManager";
import { msToTime, leadingZeros } from "../GlobalHelperFunctions";
import { NudgeFactory } from "../NudgeFactory";
import { FailedInviteDialog } from "./FailedInviteDialog";
import { GachaScreen } from "./GachaScreen";
import { MatildaRewardDialog } from "./MatildaRewardDialog";
import { WarningDialog } from "./WarningDialog";
tgfSettings.dialogDefaults.angryLobbyDialog = {
    backgroundImage: null,
    listSpacing: 28,
    lobbyButtonXOffset: 26,
    lobbyButtonTextXOffset: -25,
    cardCenterOffset: 0,
    expBarWidth: 120,
    expBarHeight: 11,
    listOffset: [
        {
            x: 0,
            y: 0
        },
        {
            x: 0,
            y: 0
        },
        {
            x: 0,
            y: 0
        }
    ],
    paddingTop: 40,
    paddingBottom: 20,
    componentLobbyListClass: ComponentLobbyList,
    componentLobbyListItemClass: tgfComponents.ComponentLobbyListItem,
    lobbyListItems: {},
    headings: {
        active: 'YOUR TURN',
        inactive: 'THEIR TURN',
        done: 'FINISHED MATCHES',
        suggested: 'SUGGESTED PLAYERS'
    },
    listMatches: null,
    playButtonElastic: { effect: tgfEffects.popElastic, duration: 4, startScaleX: 1, endScaleX: 1.25, startScaleY: 1, endScaleY: 0.9, easeArgument: 1, name: "elastic" },
    components: [] // The additional components to add
};
export var AngryLobbyDialog = function (properties) {
    "use strict";
    this.name = "AngryLobbyDialog"; // The name of the dialog
    this.disableInput = false; // If enabled blocks input on buttons
    this.musicID = null;
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.angryLobbyDialog);
    // add base settings
    if (tgfSettings.lobbyScreenDialogProperties) {
        this.setProperties(tgfSettings.lobbyScreenDialogProperties);
    }
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.newFriendGameLabel_X = -120 + this.lobbyButtonTextXOffset;
    this.newRandomGameLabel_X = 0;
    this.newFriendGameLabel_Y = 65;
    this.newRandomGameLabel_Y = 90;
    var self = this;
    this.backendListener = {
        triggered: false,
        messageReceived: function (msg, source) {
            self.onBackendMessage(msg);
        },
        playerConnected: function (userId) { },
        playerRoomUpdate: function (userId, currentMatchId) { },
        playerDisconnected: function (userId) { }
    };
};
// Inherit the base dialog
tgfDialogs.inherit(AngryLobbyDialog, DialogLobby);
AngryLobbyDialog.prototype.storeLobbyItemComponent = function (comp, type) {
    "use strict";
    if (!this.lobbyListItems[type])
        this.lobbyListItems[type] = [];
    this.lobbyListItems[type].push(comp);
};
AngryLobbyDialog.prototype.handleEndStep = function (timeStep) {
    "use strict";
    AngryLobbyDialog.uber.handleEndStep.call(this, timeStep);
    //If an icon exists then we know the UI is initialized properly
    //If the scale is other than 1 then it's been modified
    if (this.newRandomGame.icon && this.newRandomGame.icon.scaleX !== 1) {
        this.newRandomGameLabel.x = this.newRandomGameLabel_X;
        this.newRandomGameLabel.y = this.newRandomGameLabel_Y - 11;
        this.newFriendGameLabel.x = this.newFriendGameLabel_X;
        this.newFriendGameLabel.y = this.newFriendGameLabel_Y;
    }
    else if (this.newFriendGame.icon && this.newFriendGame.icon.scaleX !== 1) {
        this.newFriendGameLabel.x = this.newFriendGameLabel_X;
        this.newFriendGameLabel.y = this.newFriendGameLabel_Y - 11;
        this.newRandomGameLabel.x = this.newRandomGameLabel_X;
        this.newRandomGameLabel.y = this.newRandomGameLabel_Y;
    }
    else {
        this.newRandomGameLabel.x = this.newRandomGameLabel_X;
        this.newRandomGameLabel.y = this.newRandomGameLabel_Y;
        this.newFriendGameLabel.x = this.newFriendGameLabel_X;
        this.newFriendGameLabel.y = this.newFriendGameLabel_Y;
    }
    this.newRandomGameLabel.setScale(this.newRandomGame.icon.scaleX, this.newRandomGame.icon.scaleY);
    var timeToEnd = DailyRewardManager.getTerenceTimeRemaining();
    if (timeToEnd < 0) {
        this.terenceTimer.hide();
    }
    else {
        this.terenceTimer.show();
        var times = msToTime(timeToEnd);
        var timeString = leadingZeros(times.hours, 2) + ":" + leadingZeros(times.minutes, 2) + ":" + leadingZeros(times.seconds, 2);
        this.terenceTimerCountdown.setText(timeString);
    }
    // var test = (Math.sin(Date.now() / 1000 * Math.PI * 2) + 1.5);
    // this.inviteProgressLabel.setScale(test, test);
    var nextProgress = this.currentProgress;
    var increment = timeStep / 2000;
    if (this.currentProgress + increment < this.matildaAnimationTarget) {
        nextProgress += increment;
        this._setMatildaAnimationPercentage(nextProgress);
    }
    else if (this.currentProgress < this.matildaAnimationTarget) {
        this._setMatildaAnimationPercentage(this.matildaAnimationTarget);
    }
    else if (this.currentProgress === this.matildaAnimationTarget && this.afterFillAnimation) {
        this.afterFillAnimation();
        this.afterFillAnimation = null;
    }
    if (this.inviteProgressLabelScale - 3 * increment > 1) {
        this.inviteProgressLabelScale -= 3 * increment;
        this.inviteProgressLabel.setScale(this.inviteProgressLabelScale, this.inviteProgressLabelScale);
    }
    else if (this.inviteProgressLabelScale > 1) {
        this.inviteProgressLabelScale = 1;
        this.inviteProgressLabel.setScale(1, 1);
    }
    else if (this.inviteProgressLabelScale === 1 && this.afterTextAnimation) {
        this.afterTextAnimation();
        this.afterTextAnimation = null;
    }
};
AngryLobbyDialog.prototype.onBackendMessage = function (msg) {
    console.log(msg);
    var self = this;
    if (msg["@class"] === ".ScriptMessage") {
        var data = msg["data"];
        var id = data["challengeId"];
        var msg = data["msg"] ? data["msg"]["event"] : "undefined";
        if (id && msg == "end_turn") {
            var dialog = gameController.chooseAFriend || this.notYourTurn || this.optionScreen;
            if (dialog) {
                var oldOnClose = dialog.onClose;
                dialog.onClose = function () {
                    if (oldOnClose) {
                        oldOnClose();
                    }
                    self._handleEndTurnMessage(id);
                };
            }
            else {
                this._handleEndTurnMessage(id);
            }
        }
    }
};
AngryLobbyDialog.prototype._handleEndTurnMessage = function (id) {
    flowController.showLobby(false);
};
/**
 * returns true if the data was valid and it actually got changed
 */
AngryLobbyDialog.prototype.setOtherPlayerAsLast = function (id, data) {
    var d = data ? data["lobby"] : null;
    if (d) {
        var initData = d["initiatingPlayerData"];
        var otherData = d["otherPlayerData"];
        var initId = initData ? initData["id"] : "";
        var otherId = otherData ? otherData["id"] : "";
        if (otherId == id && initId) {
            d["lastTurnID"] = initId;
        }
        else if (initId == id && otherId) {
            d["lastTurnID"] = otherId;
        }
        else {
            return false;
        }
        return true;
    }
    return false;
};
AngryLobbyDialog.prototype.toggleInput = function (enable) {
    "use strict";
    if (!this.inputMask) {
        return;
    }
    if (enable) {
        this.inputMask.hide();
    }
    else {
        this.inputMask.show();
    }
};
AngryLobbyDialog.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    var i;
    this.headings.active = tgfDictionary.getText(this.headings.active);
    this.headings.inactive = tgfDictionary.getText(this.headings.inactive);
    this.headings.done = tgfDictionary.getText(this.headings.done);
    this.headings.suggested = tgfDictionary.getText(this.headings.suggested);
    if (!this.musicID || !tgfAudio.isPlaying(this.musicID)) {
        this.musicID = SoundManager.playEffect(SoundManager.MUSIC_STATE.LOBBY, SoundManager.MusicCollection, 0, true);
    }
    this.bgImage = new ComponentPicture({
        image: s_bg_placeholder,
        xScale: 2,
        yScale: 2
    });
    this.addComponent(this.bgImage);
    this.playerProfileBG = new ComponentPicture({
        image: s_portrait_empty,
        x: 5,
        xScale: 0.8,
        yScale: 0.8
    });
    var profileScale = profileManager.scaler(profileManager.getInfo(tgfHooks.getPlayerID()).image, 320 * 0.35);
    this.playerProfile = new ComponentPicture({
        image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
        x: 80,
        y: 80,
        xScale: profileScale,
        yScale: profileScale
    });
    this.playerXPBarBG = new ComponentPicture({
        image: s_expbar_empty,
        x: 40,
        y: 80,
        xScale: 1,
        yScale: 1
    });
    this.playerXPText = new ComponentLabel({
        text: "0%",
        x: -3,
        y: -4,
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 25,
            fillColor: "#fefefe",
            align: "center",
            textStyle: "italic",
            fontWeight: "bold",
            baseline: "middle"
        }
    });
    this.expBarBackground = new ComponentPicture({
        image: s_progressbar_bg,
        x: 10,
        y: 50,
        xScale: 0.2,
        yScale: 0.33,
    });
    this.playerProfileBG.addComponent(this.expBarBackground);
    this.expBarFill = new ComponentPicture({
        image: s_progressbar_fill_green,
        createFromSlices: true,
        sliceMargins: 4,
        width: ExpManager.getProgressPercentage(this.startingExp, this.rank) * this.expBarWidth,
        height: this.expBarHeight,
        x: -this.expBarWidth / 2 - 3,
        y: -6,
    });
    this.expBarBackground.addComponent(this.expBarFill);
    this.playerRankBG = new ComponentPicture({
        image: ExpManager.getRankAssets().emblem,
        x: -50,
        y: 50,
        xScale: 0.33,
        yScale: 0.33
    });
    this.playerRank = new ComponentLabel({
        text: ExpManager.getRank().toString(),
        font: {
            fontFace: angrybirds_regular_text.fontFace,
            fontSize: 24,
            fillColor: "#503d25",
            align: "center",
            textStyle: "italic",
            fontWeight: "bold",
            baseline: "middle"
        }
    });
    this.playerGemsBG = new ComponentPicture({
        image: s_gemcontainer,
        x: 20,
        y: 75,
        xScale: 0.9,
        yScale: 0.9
    });
    this.playerGemsBadgeBG = new ComponentPicture({
        image: s_badgebg,
        x: -90,
        xScale: 0.85,
        yScale: 0.85
    });
    this.playerGems = new ComponentPicture({
        image: s_icon_gem,
        xScale: 0.7,
        yScale: 0.7
    });
    // Gems display
    //this.playerGemsBadgeBG.addComponent(this.playerGems);
    //this.playerGemsBG.addComponent(this.playerGemsBadgeBG);
    //this.playerGemsBG.addComponent(playerGemsLabel);
    //gemMtxButton.addComponent(gemMtxButtonIcon);
    //this.playerGemsBG.addComponent(gemMtxButton);
    // XP Bar
    // this.playerXPBarBG.addComponent(this.playerGemsBG);
    // this.playerXPBarBG.addComponent(this.playerXPText);
    // Profile picture + rank
    // this.playerProfile.addComponent(this.playerXPBarBG);
    this.playerProfile.addComponent(this.playerProfileBG);
    this.playerRankBG.addComponent(this.playerRank);
    this.playerProfile.addComponent(this.playerRankBG);
    this.addComponent(this.playerProfile);
    var leftButtonsYOffset = 40;
    this.settingsButton = new ComponentButton({
        x: tgfGraphics.areaWidth - 30,
        y: 710 + leftButtonsYOffset,
        image: s_btn_round_blue,
        icon: s_icon_settings,
        iconPosition: "center",
        onClick: function (comp) {
            console.log("Settings");
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.optionScreen = new AngryOptionScreenDialog({
                optionSettings: ["music", "sfx", "tutorial"],
                width: 800, height: 650,
                onClose: function () { self.optionScreen = null; }
            });
            self.optionScreen.show();
        }
    });
    this.addComponent(this.settingsButton);
    this.videoContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth - 36 + (-8),
        y: 170
    });
    // Enable this if you want to re-enable the watch an ad/gacha button
    // this.addComponent(this.videoContainer);
    this.watchVideo = new ComponentButton({
        image: s_btn_round_orange_big,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.hide();
            AngryAnalytics.reportUXButton("powerups_button");
            self.gachaScreen = new GachaScreen(function () {
                self.gachaScreen = null;
                flowController.showLobby(false);
            }, false);
        }
    });
    this.videoContainer.addComponent(this.watchVideo);
    this.watchVideoGrey = new ComponentButton({
        image: s_btn_round_grey_big,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.hide();
            self.gachaScreen = new GachaScreen(function () {
                self.gachaScreen = null;
                flowController.showLobby(false);
            });
        }
    });
    this.videoContainer.addComponent(this.watchVideoGrey);
    // this.leaderboardButtonContainer = this.createLeaderboardButton();
    // this.videoContainer.addComponent(this.leaderboardButtonContainer);
    this.videoLabelTimer = "1:1:1";
    this.videoLabel = new ComponentLabel({
        text: this.videoLabelTimer,
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 34,
            fillColor: "#763a0e",
            align: "center",
            baseline: "middle",
            wordWrap: true,
            wordWrapWidth: s_button_rectangle2_white.width * 0.75
        },
        fitToBox: true,
        width: s_button_rectangle2_white.width * 0.3,
        height: s_button_rectangle2_white.height * 0.27,
        y: 0
    });
    var videoBG = new ComponentPicture({
        image: s_button_rectangle2_white,
        x: -this.watchVideo.image.width / 2,
        y: 30,
        xScale: (this.videoLabel.width / s_button_rectangle2_white.width) * 3,
        yScale: (this.videoLabel.height / s_button_rectangle2_white.height) * 3.65
    });
    videoBG.addComponent(this.videoLabel);
    this.videoContainer.addComponent(videoBG);
    var videoIcon = new ComponentPicture({
        image: s_icon_powerup,
        x: -this.watchVideo.image.width / 2,
        y: -this.watchVideo.image.height / 2,
        xScale: 1.2,
        yScale: 1.2
    });
    this.videoContainer.addComponent(videoIcon);
    var powerPlus = new ComponentPicture({
        x: -13,
        y: -45,
        image: s_powerupcount
    });
    this.powerPlusText = new ComponentLabel({
        text: "0",
        y: -2,
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 36,
            align: "center",
            baseline: "middle",
            fillColor: "#531c01",
            fontStyle: 'bold',
            shadow: { active: false }
        }
    });
    powerPlus.addComponent(this.powerPlusText);
    this.videoContainer.addComponent(powerPlus);
    if (inventoryController.showRefillNotification()) {
        this.exclamationMark = new ComponentSpine({
            x: -130,
            y: -122,
            spineAnimation: s_notification,
            animationClip: "notification_animation",
            repeat: true
        });
        this.videoContainer.addComponent(this.exclamationMark);
    }
    //Populate the data
    this._getInitialData();
    this.newFriendGame = new ComponentButton({
        x: tgfGraphics.areaWidth / 2 + s_startFriend.xOrigin - this.cardCenterOffset + this.lobbyButtonXOffset,
        y: this.paddingTop + s_startFriend.height / 2,
        icon: s_startFriend,
        iconPosition: 'right',
        image: transparent_4x4,
        onClick: function (component) {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.toggleInput(false);
            gameController.startNewGame(function () {
                flowController.freeLobby();
            }, function () {
                self.toggleInput(true);
            });
        }
    });
    this.newFriendGameLabel = new ComponentLabel({
        text: tgfDictionary.getText("BTN_FRIEND_MATCH"),
        x: this.newFriendGameLabel_X,
        y: this.newFriendGameLabel_Y,
        fitToBox: true,
        splitLines: true,
        width: s_startFriend.width - 120,
        height: 70,
        angle: -10 * (Math.PI / 180),
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 30,
            align: "center",
            baseline: "middle",
            fillColor: "#1e410a"
        }
    });
    this.newFriendGame.addComponent(this.newFriendGameLabel);
    // var newFriendExclamation = new ComponentSpine({
    //     alpha: leaderboardManager.showExclamationMark() ? 0 : 1,
    //     x: -270,
    // 	y: -140,
    // 	spineAnimation: s_notification,
    // 	animationClip: "notification_animation",
    // 	repeat: true
    // });
    // this.newFriendGame.addComponent(newFriendExclamation);
    this.newRandomGame = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: this.paddingTop + s_startRandom.height / 2,
        icon: s_startRandom,
        iconPosition: 'center',
        image: transparent_4x4,
        xScale: 0.8,
        yScale: 0.8,
        onClick: function (component) {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            gameController.startPlay({}, 0, false, true, true, null, function () {
                flowController.freeLobby();
            });
        }
    });
    this.newRandomGameLabel = new ComponentLabel({
        text: tgfDictionary.getText("BTN_QUICK_PLAY"),
        x: this.newRandomGameLabel_X,
        y: this.newRandomGameLabel_Y,
        fitToBox: true,
        splitLines: true,
        width: s_startRandom.width - 120,
        height: 70,
        // angle: 10 * (Math.PI / 180),
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 48,
            align: "center",
            baseline: "middle",
            fillColor: "#7d2d01"
        }
    });
    this.newRandomGame.addComponent(this.newRandomGameLabel);
    // var newRandomExclamation = new ComponentSpine({
    //     alpha: leaderboardManager.showExclamationMark() ? 0 : 1,
    //     x: -230,
    // 	y: -160,
    // 	spineAnimation: s_notification,
    // 	animationClip: "notification_animation",
    // 	repeat: true
    // });
    // this.newRandomGame.addComponent(newRandomExclamation);
    this.inviteFriends = new ComponentPicture({
        image: s_friend_invite_matilda,
        y: 300,
        x: 135,
    });
    // Uncomment this to reenable matilda invites
    // this.addComponent(this.inviteFriends);
    var btnImg = s_btn_round_green_small;
    this.inviteFriendsButton = new ComponentButton({
        image: btnImg,
        icon: s_icon_plus,
        iconXScale: 0.5,
        iconYScale: 0.5,
        iconPosition: "center",
        x: btnImg.width / 2,
        y: 65 + btnImg.height / 2,
        touchMarginBox: [50, 150, 50, 50],
        onClick: function () {
            self.toggleInput(false);
            AngryAnalytics.reportUXButton("matilda");
            inviteFriendManager.startInvite(function () {
                console.log("Success Invite");
                self.sendInvite(inviteFriendManager.getInvited().length - 1);
                self.updateMatildaProgress(false);
            }, function () {
                console.log("Duplicate Invite");
                var dialog = new FailedInviteDialog({
                    onClose: function () {
                        self.toggleInput(true);
                    }
                });
                dialog.show();
            }, function (err) {
                console.log("Fail Invite");
                console.log(err);
                if (err.code != "USER_INPUT") {
                    var dialog = new FailedInviteDialog({
                        onClose: function () {
                            self.toggleInput(true);
                        }
                    });
                    dialog.show();
                }
                else {
                    self.toggleInput(true);
                }
            });
        }
    });
    this.inviteFriends.addComponent(this.inviteFriendsButton);
    this.inviteFriendsLabel = new ComponentLabel({
        text: tgfDictionary.getText("INVITE_FRIENDS_TEXT"),
        y: -115,
        angle: -1 / 20,
        font: DialogSettings.textFontSmall,
    });
    this.inviteFriends.addComponent(this.inviteFriendsLabel);
    this.inviteProgressBar = this.createProgressBar(-54, 105);
    this.inviteFriends.addComponent(this.inviteProgressBar);
    this.inviteProgressLabel = new ComponentLabel({
        text: "0/3",
        font: DialogSettings.textFontSmall,
        x: 0,
        y: 115,
    });
    this.inviteFriends.addComponent(this.inviteProgressLabel);
    this.terenceTimer = new ComponentPicture({
        image: s_terence_timer_lobby,
        y: tgfGraphics.areaHeight - s_terence_timer_lobby.height,
        x: 20,
    });
    this.addComponent(this.terenceTimer);
    this.terenceTimerLabel = new ComponentLabel({
        text: tgfDictionary.getText("TIME_LEFT_TEXT"),
        x: s_terence_timer_lobby.width / 2 + 13,
        y: 210,
        font: DialogSettings.textFontSmall,
        height: 20,
        width: 100
    });
    this.terenceTimer.addComponent(this.terenceTimerLabel);
    this.terenceTimerCountdown = new ComponentLabel({
        text: "HH:MM:SS",
        x: s_terence_timer_lobby.width / 2 + 13,
        y: 233,
        font: DialogSettings.textFontSmall,
        height: 30,
        width: 100
    });
    this.terenceTimer.addComponent(this.terenceTimerCountdown);
    // TODO Think of a different way to add top height??? -Mike
    // list active games
    var posY = s_startFriend.height + this.listOffset[0].y;
    // // list active games
    // var posY = this.paddingTop + this.listOffset[0].y;
    var listHeight;
    var showExclamationOnPlay = false;
    var tempfont = new tbVectorFont();
    tempfont.setProperties(this.font);
    // if(this._data.active.length > 0){
    //     this._listActive = new this.componentLobbyListClass({
    //         type: 'active',
    //         x: this.listOffset[0].x,
    //         y: posY,
    //         items: this._data.active,
    //         componentItemClass: this.componentLobbyListItemClass,
    //         headingText: this.headings.active,
    //         font: tempfont
    //     });
    // } else {
    //     showExclamationOnPlay = true;
    //     this._data.active = [{}];
    //     this._listActive = new this.componentLobbyListClass({
    //         type: 'activeEmpty',
    //         x: this.listOffset[0].x,
    //         y: posY,
    //         items: this._data.active,
    //         componentItemClass: this.componentLobbyListItemClass,
    //         headingText: this.headings.active,
    //         font: tempfont
    //     });
    // }
    // var activeBg = new ComponentPicture({
    //     image: s_button_rectangle_white,
    //     createFromSlices: true,
    //     sliceMarginsArray: [20,20,20,20],
    //     width: 720,
    //     height: 300,
    //     x: 324 + this.listOffset[0].x, 
    //     y: -10
    // });
    // // list suggested players
    // listHeight = this._listActive.getHeight();
    // posY = this._listActive.y + listHeight + this.listSpacing + this.listOffset[1].y;
    // activeBg.height = listHeight - 90;
    // this._listActive.addComponent(activeBg);
    // tempfont.shadow.color = "rgba(82, 54, 22, 0.9)"; // #523616
    // this._data.suggested = FriendManager.getSuggestedFriends(MiscSettings.numberOfSuggestedFriends);
    // this._canSuggest = (this._data.suggested.length > 0);
    // if(this._canSuggest){
    // 	this._listSuggested = new this.componentLobbyListClass({
    // 		type: 'suggested',
    // 		x: this.listOffset[1].x,
    // 		y: posY,
    // 		items: this._data.suggested,
    // 		componentItemClass: this.componentLobbyListItemClass,
    // 		headingText: this.headings.suggested,
    // 		font: tempfont
    // 	});
    // 	var suggestedbg = new ComponentPicture({
    // 		image: s_button_rectangle_white,
    // 		createFromSlices: true,
    // 		sliceMarginsArray: [20,20,20,20],
    // 		width: 720,
    // 		height: 300,
    // 		x: 324 + this.listOffset[1].x,
    // 		y: -10
    // 	});
    // 	this._listSuggested.imageTop = s_bar_title_blue;
    // 	this._listSuggested.imageItem = s_bar_container_blue;
    // } else {
    // 	this._listSuggested = {
    // 		x: this.listOffset[1].x,
    // 		y: posY,
    // 		getHeight: function(){
    // 			return 0;
    // 		}
    // 	};
    // }
    // // list inactive games
    // listHeight = this._listSuggested.getHeight();
    // posY = this._listSuggested.y + listHeight + this.listSpacing + (this._canSuggest ? this.listOffset[2].y : this.listOffset[1].y);
    // if(this._canSuggest){
    // 	suggestedbg.height = listHeight - 90;
    // 	this._listSuggested.addComponent(suggestedbg);
    // }
    // tempfont.shadow.color = "rgba(82, 54, 22, 0.9)"; // #523616
    // if(this._data.inactive.length > 0){
    //     this._listInactive = new this.componentLobbyListClass({
    //         type: 'inactive',
    //         x: this.listOffset[2].x,
    //         y: posY,
    //         items: this._data.inactive,
    //         componentItemClass: this.componentLobbyListItemClass,
    //         headingText: this.headings.inactive,
    //         font: tempfont
    //     });
    // } else {
    //     this._data.inactive = [{}];
    //     this._listInactive = new this.componentLobbyListClass({
    //         type: 'inactiveEmpty',
    //         x: this.listOffset[2].x,
    //         y: posY,
    //         items: this._data.inactive,
    //         componentItemClass: this.componentLobbyListItemClass,
    //         headingText: this.headings.inactive,
    //         font: tempfont
    //     });
    // }
    // var inactiveBg = new ComponentPicture({
    //     image: s_button_rectangle_white,
    //     createFromSlices: true,
    //     sliceMarginsArray: [20,20,20,20],
    //     width: 720,
    //     height: 300,
    //     x: 324 + this.listOffset[2].x,
    //     y: -10
    // });
    // this._listInactive.imageTop = s_bar_title_yellow;
    // this._listInactive.imageItem = s_bar_container_yellow;
    // // list completed/done games
    // listHeight = this._listInactive.getHeight();
    // posY = this._listInactive.y + listHeight + this.listSpacing + this.listOffset[3].y;
    // inactiveBg.height = listHeight - 90;
    // this._listInactive.addComponent(inactiveBg);
    // tempfont.shadow.color = "rgba(53, 58, 66, 0.9)"; // #353a42
    // if(this._data.done.length > 0){
    //     this._listDone = new this.componentLobbyListClass({
    //         type: 'done',
    //         x: this.listOffset[3].x,
    //         y: posY,
    //         items: this._data.done,
    //         componentItemClass: this.componentLobbyListItemClass,
    //         headingText: this.headings.done,
    //         font: tempfont
    //     });
    // } else {
    //     this._data.done = [{}];
    //     this._listDone = new this.componentLobbyListClass({
    //         type: 'doneEmpty',
    //         x: this.listOffset[3].x,
    //         y: posY,
    //         items: this._data.done,
    //         componentItemClass: this.componentLobbyListItemClass,
    //         headingText: this.headings.done,
    //         font: tempfont
    //     });
    // }
    // var doneBg = new ComponentPicture({
    //     image: s_button_rectangle_white,
    //     createFromSlices: true,
    //     sliceMarginsArray: [20,20,20,20],
    //     width: 720,
    //     height: 300,
    //     x: 324 + this.listOffset[3].x,
    //     y: -10
    // });
    // listHeight = this._listDone.getHeight();
    // doneBg.height = listHeight - 90;
    // this._listDone.addComponent(doneBg);
    // tempfont.free();
    // this._listDone.imageTop = s_bar_title_grey;
    // this._listDone.imageItem = s_bar_container_grey;
    this.lobbyHeader = new ComponentPicture({
        image: s_button_rectangle2_white,
        x: (tgfGraphics.areaWidth / 2) - s_button_rectangle2_white.width * 2,
        y: 20,
        // xScale: 4,
        // yScale: 0.5,
        createFromSlices: true,
        sliceMarginsArray: [20, 20, 20, 20],
        height: s_button_rectangle2_white.height * 0.5,
        width: s_button_rectangle2_white.width * 4
    });
    this.lobbyHeaderLabel = new ComponentLabel({
        text: tgfDictionary.getText("START_NEW_GAME_TEXT"),
        x: this.lobbyHeader.width / 2,
        y: this.lobbyHeader.height * 0.45,
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 34,
            fillColor: "#095618",
            align: "center",
            baseline: "middle"
        }
    });
    this.lobbyHeader.addComponent(this.lobbyHeaderLabel);
    // container
    this._listContainer = new ComponentContainer({});
    this._listContainer.components.push(this.lobbyHeader);
    // this._listContainer.components.push(this.newFriendGame);
    this._listContainer.components.push(this.newRandomGame);
    // this._listContainer.components.push(this.newPracticeGame);
    // this._listContainer.components.push(this._listActive);
    // if(this._canSuggest){
    // 	this._listContainer.components.push(this._listSuggested);
    // }
    // this._listContainer.components.push(this._listInactive);
    // this._listContainer.components.push(this._listDone);
    // var areaHeight = this._listDone.y + this._listDone.getHeight() + this.paddingBottom;
    // scroll
    // var scrollProps: any = {};
    // scrollProps.x = tgfGraphics.areaWidth/2;
    // scrollProps.y = tgfGraphics.areaHeight/2;
    // scrollProps.scrollHorizontal = false;				// Whether to allow horizontal scrolling
    // scrollProps.scrollVertical = true;				// Whether to allow vertical scrolling
    // scrollProps.width = tgfGraphics.areaWidth;
    // scrollProps.height = tgfGraphics.areaHeight;						// The height of the area in the box
    // scrollProps.areaWidth = tgfGraphics.areaWidth;						// The width of the area in the box
    // scrollProps.areaHeight = areaHeight;						// The height of the area in the box
    // scrollProps.clip = true;							// Whether to clip the subcomponents
    // scrollProps.showHorizontalScrollBar = false;		// Whether to show the horizontal scroll bar when required
    // scrollProps.showVerticalScrollBar = false;		// Whether to show the vertical scroll bar when required
    // scrollProps.cancelEvents = false;
    this._scrollBox = new ComponentScrollBox({});
    // this._scrollBox.components.push(this._listContainer);
    this.components.push(this._listContainer);
    this.doPrepareCustom();
    // Add the additional components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
    // this._listActive._hasLast = false;
    // this._listInactive._hasLast = false;
    // this._listDone._hasLast = false;
    // this._listSuggested._hasLast = false;
    this.inputMask = new DialogBase();
    this.inputMask.addComponent(new ComponentButton({
        image: transparent_4x4,
        xScale: 1000000,
        yScale: 1000000,
        x: -1000,
        y: -1000,
    }));
};
AngryLobbyDialog.prototype.updateMatildaProgress = function (skipAnimation) {
    return; // Remove this to reenable matilda invites
    var self = this;
    var progress = inviteFriendManager.getInvited().length;
    var max = CardSettings.maxMatildaInvites;
    this.matildaAnimationTarget = progress / max;
    if (skipAnimation) {
        this.inviteProgressLabel.setText(progress + "/" + max);
        this._setMatildaAnimationPercentage(this.matildaAnimationTarget);
        if (progress >= max) {
            this.inviteFriends.hide();
        }
    }
    else {
        this.afterFillAnimation = function () {
            this.inviteProgressLabel.setText(progress + "/" + max);
            this.inviteProgressLabel.setScale(2, 2);
            this.inviteProgressLabelScale = 2;
            this.afterTextAnimation = function () {
                if (inviteFriendManager.unlockBird()) {
                    var dialog = new MatildaRewardDialog({
                        onClose: function () {
                            self.toggleInput(true);
                            self._showSmoke(function () {
                                self.inviteFriends.hide();
                            });
                            tgfAudio.stop("music");
                            SoundManager.playEffect(SoundManager.MUSIC_STATE.LOBBY, SoundManager.MusicCollection, 0, false);
                        }
                    });
                    dialog.show();
                    tgfAudio.stop("music");
                    SoundManager.playEffect(SoundManager.MUSIC_STATE.STINGER_WIN, SoundManager.MusicCollection, 0, false);
                }
                else {
                    self.toggleInput(true);
                }
            };
        };
    }
};
AngryLobbyDialog.prototype._showSmoke = function (onEvent) {
    var self = this;
    this._smoke = new ComponentSpine({
        spineAnimation: s_smokePuff,
        animationClip: "s_smoke_puff_matilda",
        repeat: false,
        x: this.inviteFriends.x,
        y: this.inviteFriends.y,
        scale: 2,
    });
    this.addComponent(this._smoke);
    if (onEvent) {
        // Hack because the smokepuff only has an event for chuck
        // TODO: replace this with a proper spine event if we get a version of the animation with events
        setTimeout(onEvent.bind(this), 166.7);
    }
    this._smoke.show();
    this._smoke.activate();
    this._smoke.setAnimation("s_smoke_puff_matilda", function () {
        self._smoke.hide();
        self.inviteFriends.removeComponent(self._smoke);
    });
};
AngryLobbyDialog.prototype._setMatildaAnimationPercentage = function (percentage) {
    var progressWidth = 106 * percentage;
    this.progressFill.setDimensions(progressWidth, s_progress_bar_fill.height / 2);
    this.currentProgress = percentage;
};
AngryLobbyDialog.prototype.createProgressBar = function (x, y) {
    var container = new ComponentContainer({
        x: x,
        y: y,
    });
    this.progressFill = new ComponentPicture({
        image: s_progress_bar_fill,
        createFromSlices: true,
        sliceMargins: 1,
    });
    container.addComponent(this.progressFill);
    return container;
};
AngryLobbyDialog.prototype.onShow = function () {
    "use strict";
    var PUCount = inventoryController.getFilledPowerUps();
    // this.powerPlusText.setText(PUCount.toString());
    // this.newPracticeGameLabel_X = this.newPracticeGameLabel.x;
    // this.newPracticeGameLabel_Y = this.newPracticeGameLabel.y;
    this.newRandomGameLabel_X = this.newRandomGameLabel.x;
    this.newRandomGameLabel_Y = this.newRandomGameLabel.y;
    this.newFriendGameLabel_X = this.newFriendGameLabel.x;
    this.newFriendGameLabel_Y = this.newFriendGameLabel.y;
    // gamesBackendService.addListener(this.backendListener);
};
AngryLobbyDialog.prototype.onHide = function () {
    "use strict";
    // leaderboardManager.closeLeaderboard();
    // gamesBackendService.removeListener(this.backendListener);
};
AngryLobbyDialog.prototype._getInitialData = function () {
    "use strict";
    console.log("List: ", this.listMatches);
    this._matches = [];
    this._data = {};
    // this._data.active = [];
    // this._data.inactive = [];
    this._data.done = [];
    this.playerId = tgfHooks.getPlayerID();
    if (Object.keys(this.listMatches).length > 0) {
        var matches = Object.keys(this.listMatches);
        var length = Object.keys(this.listMatches).length;
        for (var i = 0; i < length; i++) {
            var matchId = String(matches[i]);
            var matchData = this.listMatches[matchId];
            var isInitiatingPlayer = (matchData["lobby"]["initiatingPlayerData"]["id"] === this.playerId);
            var didWin = isInitiatingPlayer ? matchData["lobby"]["initiatingPlayerData"]["won"] : matchData["lobby"]["otherPlayerData"]["won"];
            var playerTurn = true;
            if (matchData["lobby"]["lastTurnID"] === this.playerId) {
                playerTurn = false;
            }
            var completed = matchData["lobby"]["state"] === "GAMEOVER" ? true : false;
            if (completed === true && !matchData["lobby"]["watchedFinalReplay"] && didWin === false) {
                completed = false;
            }
            var context = matchData["lobby"]["context"];
            var playerInfo = "";
            var playerId = "";
            var matchInfo = null;
            if (matchData["lobby"]["initiatingPlayerData"]["id"] !== tgfHooks.getPlayerID()) {
                playerId = matchData["lobby"]["initiatingPlayerData"]["id"];
                playerInfo = profileManager.getInfo(playerId);
                matchInfo = {
                    "hasWon": matchData["lobby"]["otherPlayerData"]["won"],
                    "mScore": matchData["lobby"]["otherPlayerData"]["totalPigs"],
                    "oScore": matchData["lobby"]["initiatingPlayerData"]["totalPigs"]
                };
            }
            else if (matchData["lobby"]["otherPlayerData"]["id"] !== "") {
                playerId = matchData["lobby"]["otherPlayerData"]["id"];
                playerInfo = profileManager.getInfo(playerId);
                matchInfo = {
                    "hasWon": matchData["lobby"]["initiatingPlayerData"]["won"],
                    "mScore": matchData["lobby"]["initiatingPlayerData"]["totalPigs"],
                    "oScore": matchData["lobby"]["otherPlayerData"]["totalPigs"]
                };
            }
            else {
                playerInfo = {
                    name: tgfDictionary.getText('INVITE_PENDING_TEXT'),
                    image: s_profile_placeholder
                };
            }
            var _data = {
                id: matchId,
                playerId: playerId,
                data: matchData,
                turn: playerTurn,
                completed: completed,
                context: context,
                info: playerInfo,
                matchInfo: matchInfo,
                expirationDate: matchData["_challengeData"]["expirationDate"]
            };
            if (completed) {
                this._data.done.push(_data);
            }
            else {
                if (playerTurn) {
                    this._data.active.push(_data);
                }
                else {
                    this._data.inactive.push(_data);
                }
            }
        }
    }
    else {
        console.log("No Match Data");
    }
    // this._sortMatchesOnTime(this._data.active);
    // this._sortMatchesOnTime(this._data.inactive);
    this._sortMatchesOnTime(this._data.done);
};
AngryLobbyDialog.prototype._sortMatchesOnTime = function (list) {
    list.sort(function (a, b) {
        return b.expirationDate.getTime() - a.expirationDate.getTime();
    });
};
AngryLobbyDialog.prototype.decrementTimers = function () {
    if (!this.videoLabel || !this.videoLabelTimer) {
        return;
    }
    var remainingTime = inventoryController.getCooldown();
    var videoAvailableText = tgfDictionary.getText("GET_NEW_POWERUPS_TEXT");
    // if (remainingTime > 0) {
    //     if (this.watchVideo.isVisible || !this.watchVideoGrey.isVisible) {
    //         this.watchVideo.hide();
    //         this.watchVideoGrey.show();
    //         this.watchVideoGrey.activate();
    //     }
    //     var cdText = inventoryController.getCooldownText();
    //     if (this.videoLabelTimer != cdText) {
    //         this.videoLabelTimer = cdText;
    //         this.videoLabel.setText(" " + this.videoLabelTimer);
    //     }
    // } else if (!this.watchVideo.isVisible || this.watchVideoGrey.isVisible) {
    //     this.videoLabel.setText(videoAvailableText);
    //     this.watchVideo.show();
    //     this.watchVideo.activate();
    //     this.watchVideoGrey.hide();
    // }
};
AngryLobbyDialog.prototype.showNotYourTurn = function () {
    var self = this;
    this.notYourTurn = new WarningDialog({
        onHide: function () {
            self.toggleInput(true);
            self.notYourTurn = null;
        },
        text: tgfDictionary.getText("GAME_IN_PROGRESS_TEXT")
    });
    this.notYourTurn.show();
    this.toggleInput(false);
    this.notYourTurn.activate();
};
AngryLobbyDialog.prototype.sendInvite = function (inviteNumber) {
    var inviteMsg = NudgeFactory.GetPremadeNudge('update', 2, {});
    var tag = customMessagecontroller.getInviteTag();
    var matildaTag = ":matilda";
    var inviteIndex = customMessagecontroller.getMessageIndex();
    customMessagecontroller.saveIndex();
    var localizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.inviteMessage[inviteIndex], [
        tgfHooks.getPlayerName()
    ]);
    var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.inviteCTA[inviteIndex]);
    tgfHooks.updateAsync(function () {
        AngryAnalytics.reportInviteFriendsMessage(tag, inviteNumber);
    }, tag + matildaTag, inviteMsg, CTAlocalizations, localizations, { "tag": tag + matildaTag });
};
